<script lang="ts">
  import type {Classic} from '../types'
  import api from '../api/api'
  import {user} from '../stores/user'

  export let classic: Classic

  async function follow() {
    await api.put(`/classics/${classic.id}/follow`)
    classic.is_followed = true
    classic.followers_count += 1
  }

  async function unfollow() {
    await api.put(`classics/${classic.id}/unfollow`)
    classic.is_followed = null
    classic.followers_count -= 1
  }
</script>

<div class="grid__card poet__card">
  <div class="poet__name">
    <a href={classic.link}>
      {classic.full_name}
    </a>
  </div>
  <a class="poet__photo" href={classic.link}>
    <img src={classic.avatar_big_thumgb} alt={classic.full_name}/>
  </a>
  <div class="poet__info">
    <span class="poet__poem__count">
      <i class="icon-p-book"></i>
      {classic.poems_count}
    </span>
    <span class="poet__followers__count">
      <i class="icon-p-user"></i>
      {classic.followers_count}
    </span>
  </div>

  {#if $user}
    <div class="poet__actions">
      {#if !classic.is_followed}
        <span class="poet__follow__btn poet__btn follow-poet" onclick={follow}>
          <i class="icon-p-plus-circle"/>
        </span>
      {/if}

      {#if classic.is_followed}
        <span class="poet__follow__btn poet__btn follow-poet followed" onclick={unfollow}>
          <i class="icon-p-check"/>
        </span>
      {/if}
    </div>
  {/if}
</div>
